module.exports = __webpack_public_path__ + "static/media/iphone6-3up-blank.abdc9b98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone/iphone6/iphone6-3up-blank.svg
// module id = 37
// module chunks = 0